export const breakpoints = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 599,  // vuetify xs code is <600
    tabletL: 768,
    laptop: 1024,
    laptopL: 1440,
    fourK: 2560,
};

